export const SETLOGWORKLIST = "SETLOGWORKLIST";
export const SETTICKETLIST = "SETTICKETLIST";
export const SETALLTICKETLIST = "SETALLTICKETLIST";
export const SETEDITORLOGWORKDATA = "SETEDITORLOGWORKDATA";
export const CLEARDOC = "CLEARDOC";